export default [
  {
    path: "",
    name: "lead-reports",
    component: () => import("@/view/pages/reports/ReportsList.vue"),
  },
  {
    path: "campaign",
    name: "campaing-report",
    component: () => import("@/view/pages/reports/CampaignReport.vue"),
  },
  {
    path: "channel",
    name: "channel-report",
    component: () => import("@/view/pages/reports/ChannelReport.vue"),
  },
  {
    path: "campaign-status",
    name: "campaign-status-report",
    component: () => import("@/view/pages/reports/CampaignStatusReport.vue"),
  },
  {
    path: "call-result-codes",
    name: "call-result-codes-report",
    component: () => import("@/view/pages/reports/CallResultCodesReport.vue"),
  },
];
